import React, { useState, useEffect } from "react";
import moment from "moment";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import CrudEvent from "./CrudEvent";

const LittleCalendarUpcoming = ({
  currentMonth,
  dayselected,
  generateDaysArray,
  setDayselected,
  appointments,
}) => {
  const [currentDate, setCurrentDate] = useState(moment(currentMonth));
  const [days, setDays] = useState([]);
  const [open, setOpen] = useState(false);
  const formattedMonth = currentDate.format("MMMM YYYY");

  useEffect(() => {
    setDays(generateDaysArray(currentDate, dayselected, appointments));
  }, [currentDate, dayselected, appointments]);

  const handlePreviousMonth = () => {
    setCurrentDate(currentDate.clone().subtract(1, "month"));
  };

  const handleNextMonth = () => {
    setCurrentDate(currentDate.clone().add(1, "month"));
  };

  return (
    <div className="mt-6 rounded-lg border border-wa-border bg-wa-panel p-4 text-center lg:col-start-8 lg:col-end-13 lg:row-start-1 lg:mt-2 xl:col-start-9">
      <div className="flex items-center text-wa-text">
        <button
          type="button"
          onClick={handlePreviousMonth}
          className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-wa-muted hover:text-wa-text"
        >
          <span className="sr-only">Previous month</span>
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
        </button>
        <div className="flex-auto text-sm font-semibold">{formattedMonth}</div>
        <button
          type="button"
          onClick={handleNextMonth}
          className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-wa-muted hover:text-wa-text"
        >
          <span className="sr-only">Next month</span>
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
      <div className="mt-4 grid grid-cols-7 text-xs leading-6 text-wa-muted">
        <div>M</div>
        <div>D</div>
        <div>W</div>
        <div>D</div>
        <div>V</div>
        <div>Z</div>
        <div>Z</div>
      </div>
      <div className="isolate mt-2 grid grid-cols-7 gap-px rounded-lg bg-wa-border text-sm shadow ring-1 ring-wa-border">
        {days.map((day, dayIdx) => (
          <button
            key={day.date}
            type="button"
            onClick={() => setDayselected(day)}
            className={classNames(
              "py-1.5 hover:bg-gray-100 focus:z-10",
              day.isCurrentMonth
              ? (day.isSelected && !day.isToday
                  ? "bg-wa-hover"
                  : "bg-wa-panel2")
                : "bg-slate-500 text-wa-text/80",
                day.isSelected &&
                `font-semibold ${
                  day.events.length > 0
                    ? "bg-wa-rowhover"
                    : "bg-wa-hover"
                }`,
              day.isToday && "text-wa-onaccent",
              !day.isCurrentMonth && !day.isToday && "text-gray-400",
              dayIdx === 0 && "rounded-tl-lg",
              dayIdx === 6 && "rounded-tr-lg",
              dayIdx === days.length - 7 && "rounded-bl-lg",
              dayIdx === days.length - 1 && "rounded-br-lg"
            )}
          >
            <time
              dateTime={day.date}
              className={classNames(
                "mx-auto flex h-7 w-7 items-center justify-center rounded-full",
                day.isSelected && day.isToday && "bg-wa-accent",
                day?.events?.length > 0 && "bg-wa-accent text-wa-onaccent",
                day.isToday && "bg-wa-accentdeep"
              )}
            >
              {day.date.split("-").pop().replace(/^0/, "")}
            </time>
          </button>
        ))}
      </div>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="mt-6 w-full rounded-md bg-wa-accent px-3 py-2 text-sm font-semibold text-wa-onaccent shadow hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent"
      >
        Afspraak maken
      </button>
      <CrudEvent openModel={open} setOpenModal={setOpen} />
    </div>
  );
};

export default LittleCalendarUpcoming;

// Helper function for class names
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
